import PropTypes from 'prop-types'

export const sanityPathLinkPropTypes = {
  _type: PropTypes.oneOf(['pathLink']),
  path: PropTypes.string,
}

export type SanityPathLinkProps = PropTypes.InferProps<typeof sanityPathLinkPropTypes>
